import axios from 'axios';
import authHeader from './auth-header';


const API_URL = process.env.VUE_APP_API_URL+'api/v1/';

class AuthService {
  login(user) {
    return axios
      .post(API_URL + 'login?include=user.role', {
        email: user.email,
        password: user.password
      })
      .then(response => {
        if (response.data.access_token) {
          localStorage.setItem('user', JSON.stringify(response.data));
        }
        return response.data;
      });
  }

  logout() {
    axios
      .get(API_URL + 'logout',{ headers: authHeader() })
      .then(response => {
        localStorage.removeItem('user');
      });
  }

  register(user) {
    return axios.post(API_URL + 'register', {
      name: user.name,
      email: user.email,
      password: user.password,
      password_confirmation: user.password_confirmation
    });
  }
}

export default new AuthService();
